import CamposParametrosFiscais, { CampoParametro } from "pages/fiscal/parametrosFiscais/CamposParametrosFiscais";
import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import { Label } from "components/input/Label";
import ComponenteProduto from "model/administracao/cadastro/produto/ComponenteProduto";
import FamiliaProduto from "model/administracao/cadastro/produto/FamiliaProduto";
import Produto from "model/administracao/cadastro/produto/Produto";
import ProdutoEstagioPlano from "model/administracao/cadastro/produto/ProdutoEstagioPlano";
import Estagio from "model/producao/Estagio";
import EstagioRoteiro from "model/producao/EstagioRoteiro";
import Roteiro from "model/producao/Roteiro";
import PlanoInspecao from "model/qualidade/PlanoInspecao";
import { AutoComplete } from "primereact/autocomplete";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { TabPanel, TabView } from "primereact/tabview";
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ProdutoService from "service/administracao/cadastro/produto/ProdutoService";
import { produtoCompleteMethod, produtoItemTemplate } from "utils/autocompleteUtils";
import "react-hook-form"
import { Controller, useForm } from "react-hook-form";
import Modulo from "model/administracao/cadastro/Modulo";
import ContaService from "service/administracao/cadastro/ContaService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import ProdutoOperacao from "model/meta/producao/ProdutoOperacao";
import OperacaoProducao from "model/meta/producao/OperacaoProducao";
import { converterData, converterDataHora } from "utils/convert";
import InputMonetario from "components/input/InputMonetario";
import { Button } from "primereact/button";
import ModalDuplicarComponentes from "./ModalDuplicarComponentes";
import { InputTextarea } from "primereact/inputtextarea";
import ClassificacaoFiscal from "model/fiscal/ClassificacaoFiscal";
import ClassificacaoFiscalService from "service/fiscal/ClassificacaoFiscalService";

const produtoService = new ProdutoService();
const contaService = new ContaService();
const usuarioLogadoService = new UsuarioLogadoService();
const classificacaoFiscalService = new ClassificacaoFiscalService();

type Props = {
    isModal?: boolean;
    isPatrimonio?: boolean;
    onSave?: (model: Produto) => void;
}

const camposFiscal: CampoParametro<Produto>[] = [
    {
        "chave": "idSituacaoTributaria",
        "label": "Situação Tributária",
        "tipo": "referencia",
        "referencia": "situacaoTributaria"
    },
    {
        "chave": "idIcmsEspecial",
        "label": "ICMS Especial",
        "tipo": "referencia",
        "referencia": "icmsEspecial"
    },
    {
        "chave": "idReducaoImposto",
        "label": "Redução do Imposto",
        "tipo": "referencia",
        "referencia": "reducaoImposto"
    },
    {
        "chave": "idSubstituicaoTributaria",
        "label": "Substituição Tributária",
        "tipo": "referencia",
        "referencia": "substituicaoTributaria"
    },
    {
        "chave": "idDispositivoFiscal",
        "label": "Dispositivo Fiscal",
        "tipo": "referencia",
        "referencia": "dispositivoFiscal"
    }
];

export default function ProdutoCadastro(props: Props) {

    const [queryParameters] = useSearchParams();

    const { control, setFocus, clearErrors, setError, register, formState: { errors } } = useForm();

    const { msgAlerta } = useToastContext();

    const inputNomeRef = useRef<any>(null);

    const [produto, setProduto] = useState<Produto>(new Produto());
    const [titulo, setTitulo] = useState<string>('Produto');
    const [familias, setFamilias] = useState<FamiliaProduto[]>([]);
    const [classificacoesFiscais, setClassificacoesFiscais] = useState<ClassificacaoFiscal[]>([]);
    const [roteiros, setRoteiros] = useState<{ label: string, value: Roteiro }[]>([]);
    const [estagios, setEstagios] = useState<EstagioRoteiro[]>([]);
    const [estagioSelecionado, setEstagioSelecionado] = useState<EstagioRoteiro | null>(null);
    const [materiasPrimas, setMateriasPrimas] = useState<Produto[]>([]);
    const [materiasPrimasFiltradas, setMateriasPrimasFiltradas] = useState<Produto[]>([]);
    const [editando, setEditando] = useState<boolean>(false);

    const [visibleDuplicarComponentes, setVisibleDuplicarComponentes] = useState<boolean>(false);

    const [modulosDisponiveis, setModulosDisponiveis] = useState<Modulo[]>([]);

    const [planosInspecaoAcabado, setPlanosInspecaoAcabado] = useState<PlanoInspecao[]>([]);
    const [planosInspecaoAcabadoFiltrados, setPlanosInspecaoAcabadoFiltrados] = useState<PlanoInspecao[]>([]);

    const [planosInspecaoEstagio, setPlanosInspecaoEstagio] = useState<PlanoInspecao[]>([]);
    const [planosInspecaoEstagioFiltrados, setPlanosInspecaoEstagioFiltrados] = useState<PlanoInspecao[]>([]);

    const [planosInspecaoRecebimento, setPlanosInspecaoRecebimento] = useState<PlanoInspecao[]>([]);

    const [visibleOperacoes, setVisibleOperacoes] = useState<boolean>(false);
    const [operacoes, setOperacoes] = useState<OperacaoProducao[]>([]);


    useEffect(() => {
        if (!window.location.pathname.includes("cadastrar") && !props.isModal) {
            setEditando(true);
        }
        produtoService.familias().then(lista => {
            setFamilias(lista);
        }).catch(err => {
            console.log(err);
        });
        classificacaoFiscalService.getAll().then(lista => {
            setClassificacoesFiscais(lista);
        }).catch(err => {
            console.log(err);
        });
        produtoService.roteiros().then(lista => {
            const list: { label: string, value: any }[] = lista.map((item: Roteiro) => {
                return { label: item.nome, value: item };
            });
            list.unshift({ label: "Nenhum", value: null });
            setRoteiros(list);
        }).catch(err => {
            console.log(err);
        });
        produtoService.materiasPrimas().then(lista => {
            setMateriasPrimas(lista);
        }).catch(err => {
            console.log(err);
        });
        produtoService.planosInspecao("PRODUTO_ACABADO").then(lista => {
            setPlanosInspecaoAcabado(lista);
        }).catch(err => {
            console.log(err);
        });
        produtoService.planosInspecao("ESTAGIO_PRODUCAO").then(lista => {
            setPlanosInspecaoEstagio(lista);
        }).catch(err => {
            console.log(err);
        });
        produtoService.planosInspecao("RECEBIMENTO").then(lista => {
            setPlanosInspecaoRecebimento(lista);
        }).catch(err => {
            console.log(err);
        });
        contaService.getModulosDisponiveis().then(lista => {
            setModulosDisponiveis(lista);
        }).catch(err => {
            console.log(err);
        })
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioLogadoService.usuarioTemAcao(resposta, "OPERACAO_PRODUCAO_CONSULTAR")) {
                setVisibleOperacoes(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });
        if (props.isPatrimonio) {
            setProduto({ ...produto, unidadeMedida: "UN", patrimoniavel: true })
        }
    }, []);

    useEffect(() => {
        if (visibleOperacoes) {
            produtoService.operacoes().then(lista => {
                setOperacoes(lista);
            }).catch(err => {
                console.log(err);
            });
        }
    }, [visibleOperacoes])

    useEffect(() => {
        if (produto.roteiro) {
            produtoService.estagios(produto.roteiro.id).then(lista => {
                setEstagios(lista);

            }).catch(err => {
                console.log(err);
            });
        }
    }, [produto.roteiro])

    function validar() {
        if (!produto.codigo) {
            setError("codigo", { type: "manual", message: "Código é obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!produto.nome) {
            setError("nome", { type: "manual", message: "Nome é obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!produto.familiaProduto) {
            setError("familiaProduto", { type: "manual", message: "Família é obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!produto.tipo) {
            setError("tipo", { type: "manual", message: "Tipo é obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!produto.unidadeMedida) {
            setError("unidadeMedida", { type: "manual", message: "Unidade de medida é obrigatória" }, { shouldFocus: true })
            return false;
        }

        return true;
    }

    function validarPersolizado() {
        if (produto.planoInspecao && !produto.planoInspecao.id) {
            setError("planoInspecao", { type: "manual", message: "Plano de inspeção inválido" }, { shouldFocus: true })
            msgAlerta("Atenção", "Plano de inspeção inválido");
            return false;
        }

        let seqRoteiro = 0;
        let somaKgLt = 0;
        for (let i = 0; i < produto.componentes.length; i++) {
            if (produto.componentes[i].estagioRoteiro.id == 0) {
                msgAlerta("Atenção", "Estágio não selecionado para o componente " + (i + 1));
                return false;
            }
            if (!produto.componentes[i].componente) {
                msgAlerta("Atenção", "Produto não selecionado para o componente " + (i + 1));
                return false;
            }
            if (produto.componentes[i].quantidade <= 0) {
                msgAlerta("Atenção", "Quantidade inválida para o componente " + (i + 1));
                return false;
            }
            if (produto.componentes[i].estagioRoteiro.sequencial > seqRoteiro) {
                seqRoteiro = produto.componentes[i].estagioRoteiro.sequencial;
                if (i > 0 && isKgouLt(produto.componentes[i - 1].componente.unidadeMedida) && somaKgLt != 100) {
                    msgAlerta("Atenção", "Percentual total diferente de diferente de 100 no estágio " + produto.componentes[i - 1].estagioRoteiro.estagio.nome + ".");
                    return false;
                }
                somaKgLt = 0;
            }
            if (isKgouLt(produto.componentes[i].componente.unidadeMedida)) {
                somaKgLt = (somaKgLt * 100000000 + produto.componentes[i].quantidade * 100000000) / 100000000;

            }
            if (produto.componentes[i].componente.unidadeMedida === "UN" && produto.componentes[i].quantidade % 1 != 0) {
                msgAlerta("Atenção", "Quantidade inválida para o componente " + (i + 1) + ". Para produtos em UN, a quantidade deve ser inteira.");
                return false;
            }

        }
        if (produto.componentes.length > 0 && isKgouLt(produto.componentes[produto.componentes.length - 1].componente.unidadeMedida) && somaKgLt != 100) {
            console.log("Soma: " + somaKgLt);
            msgAlerta("Atenção", "Percentual total diferente de diferente de 100 no estágio " + produto.componentes[produto.componentes.length - 1].estagioRoteiro.estagio.nome + ".");
            return false;
        }

        for (let i = 0; produto.planosEstagio.length > i; i++) {
            if (!produto.planosEstagio[i].estagioRoteiro || !produto.planosEstagio[i].estagioRoteiro.id) {
                msgAlerta("Atenção", "Estágio não selecionado para o plano de inspeção " + (i + 1));
                return false;
            }
            if (!produto.planosEstagio[i].planoInspecao || !produto.planosEstagio[i].planoInspecao.id) {
                msgAlerta("Atenção", "Plano de inspeção não selecionado para o estágio " + produto.planosEstagio[i].estagioRoteiro.estagio.nome);
                return false;
            }
        }
        return true;
    }

    const isKgouLt = (unidadeMedida: string) => {
        return unidadeMedida == "KG" || unidadeMedida == "LT";
    }

    const editorEstagio = (options: any) => {
        return <Dropdown
            value={options.rowData.estagioRoteiro}
            options={estagios}
            optionLabel='estagio.nome'
            onChange={(e) => {

                let componentes = [...produto.componentes];
                options.rowData.sequencial = getNextSeq(e.target.value.id);
                options.rowData['estagioRoteiro'] = e.target.value;

                componentes[options.rowIndex] = options.rowData;
                componentes = reorderEstagios(componentes);

                let produtoLocal = { ...produto };
                produtoLocal.componentes = componentes;

                setProduto(produtoLocal);
            }}
            style={{ width: '100%' }} placeholder="Selecione um Estágio" />;
    }

    const getNextSeq = (idEstagioRoteiro: number) => {
        let seq = 0;
        produto.componentes.forEach((item: ComponenteProduto) => {
            if (item.estagioRoteiro && item.estagioRoteiro.id == idEstagioRoteiro) {
                if (item.sequencial > seq) {
                    seq = item.sequencial;
                }
            }
        });
        return seq + 1;
    }


    const reorderEstagios = (componentes: ComponenteProduto[]) => {
        let listaLocal = [...componentes];
        listaLocal.sort((a, b) => {
            if (a.estagioRoteiro.sequencial > b.estagioRoteiro.sequencial) {
                return 1;
            }
            if (a.estagioRoteiro.sequencial < b.estagioRoteiro.sequencial) {
                return -1;
            }
            if (a.sequencial > b.sequencial) {
                return 1;
            }
            if (a.sequencial < b.sequencial) {
                return -1;
            }
            return 0;
        });

        return listaLocal;
    }

    const editorComponente = (options: any) => {
        return <AutoComplete
            value={options.rowData.componente}
            placeholder="Selecione um Componente"
            style={{ width: '100%' }}
            field="nome"
            itemTemplate={(item: Produto) => produtoItemTemplate(item)}
            suggestions={materiasPrimasFiltradas}
            completeMethod={(e) => {
                let filtered = produtoCompleteMethod(materiasPrimas, e.query);
                setMateriasPrimasFiltradas(filtered);
            }}
            onChange={(e) => {
                let produtoLocal = JSON.parse(JSON.stringify(produto));
                if (typeof e.target.value == "string") {
                    let prod = new Produto();
                    prod.nome = e.target.value;
                    produtoLocal.componentes[options.rowIndex].componente = prod;
                } else {
                    produtoLocal.componentes[options.rowIndex].componente = e.target.value;
                    let unimed = getUnidadeMedida(produtoLocal.componentes, options.rowData.estagioRoteiro, options.rowIndex);
                    if (unimed !== e.target.value.unidadeMedida && unimed != equivalentes[e.target.value.unidadeMedida]) {
                        msgAlerta("Atenção", "Unidade de medida diferente");
                        return;
                    }
                }
                options.rowData['componente'] = produtoLocal.componentes[options.rowIndex].componente;

                setProduto(produtoLocal);
            }}

        />

    }

    const getUnidadeMedida = (componentes: ComponenteProduto[], estagioRoteiro: EstagioRoteiro, indiceAtual: number) => {

        let componentesFiltrados = componentes.filter((item: ComponenteProduto) => item.estagioRoteiro.id == estagioRoteiro.id);

        if (componentesFiltrados.length === 1) {
            return componentesFiltrados[0].componente.unidadeMedida;
        }

        for (let i = 0; i < componentes.length; i++) {
            if (estagioRoteiro.id == componentes[i].estagioRoteiro.id && i !== indiceAtual) {
                return componentes[i].componente.unidadeMedida;
            }
        }
    }

    const equivalentes: Record<string, string> = {
        KG: "LT",
        LT: "KG"
    };

    const editorQuantidade = (options: any) => {
        return <InputNumber
            value={options.rowData.quantidade}
            suffix={isKgouLt(options.rowData.componente.unidadeMedida) ? "%" : ""}
            minFractionDigits={isKgouLt(options.rowData.componente.unidadeMedida) ? 1 : 0}
            maxFractionDigits={isKgouLt(options.rowData.componente.unidadeMedida) ? 8 : 0}
            maxLength={12}
            locale="pt-BR"
            useGrouping={false}
            onChange={(e) => {
                options.rowData['quantidade'] = e.value;
                let produtoLocal = { ...produto };
                produtoLocal.componentes[options.rowIndex] = options.rowData;
                setProduto(produtoLocal);
            }}
            style={{ width: '100%' }} />;
    }

    const editorObservacaoComponente = (options: any) => {
        return <InputTextarea rows={2} value={options.rowData.observacao} onChange={(e) => {
            options.rowData.observacao = e.target.value;
            let produtoLocal = { ...produto };
            produtoLocal.componentes[options.rowIndex] = options.rowData;
            setProduto(produtoLocal);
        }} />
    }

    const rowGroupHeaderTemplate = (data: any) => {

        return (
            <>
                <tr style={{ fontWeight: 700 }}>
                    <td colSpan={1} style={{ textAlign: 'left' }}>{data.estagioRoteiro?.sequencial + " - "}</td>
                    <td colSpan={3} style={{ textAlign: 'left' }}>{data.estagioRoteiro?.estagio.nome}</td>

                </tr>
            </>
        );
    }
    const rowGroupFooterTemplate = (data: any) => {
        let total = 0;
        let custoTotal = 0;
        let unidadeMedida = "";
        for (let i = 0; i < produto.componentes.length; i++) {

            if (produto.componentes[i].estagioRoteiro?.estagio.nome === data.estagioRoteiro?.estagio.nome) {
                if (!unidadeMedida) {
                    unidadeMedida = isKgouLt(produto.componentes[i].componente.unidadeMedida) ? "%" : produto.componentes[i].componente.unidadeMedida;
                }
                total = (total * 1000000000 + produto.componentes[i].quantidade * 1000000000) / 1000000000;
            }

            let precoComponente = produto.componentes[i].componente.precoMedio != null ? produto.componentes[i].componente.precoMedio : 0;

            if (precoComponente != null && precoComponente > 0) {
                let custo = 0;
                if (isKgouLt(produto.componentes[i].componente.unidadeMedida)) {
                    custo = (produto.componentes[i].quantidade / 100) * precoComponente;
                } else {
                    custo = produto.componentes[i].quantidade * precoComponente;
                }

                custo = Math.round(custo * 100) / 100;

                custoTotal += custo;
            }
        }
        return (
            <>
                <td colSpan={3} ></td>
                <td colSpan={1} >
                    <div style={{ fontWeight: 700, justifyContent: "right", textAlign: "right" }}>Total</div>
                </td>
                <td colSpan={1} >
                    <div className="flex justify-content-end font-bold w-full" style={{ fontWeight: 700 }}>{total + " " + unidadeMedida}</div>
                </td>
                <td colSpan={1} >
                    <div className="flex justify-content-end font-bold w-full" style={{ fontWeight: 700 }}>{custoTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                </td>
                <td colSpan={2}></td>
            </>
        )

    }

    const editorEstagioPlano = (options: any) => {
        return <Dropdown
            value={options.rowData.estagioRoteiro}
            options={estagios}
            optionLabel='estagio.nome'
            onChange={(e) => {

                let planosEstagio = [...produto.planosEstagio];
                options.rowData['estagioRoteiro'] = e.target.value;

                planosEstagio[options.rowIndex] = options.rowData;
                planosEstagio = reorderEstagiosPlano(planosEstagio);

                let produtoLocal = { ...produto };
                produtoLocal.planosEstagio = planosEstagio;

                setProduto(produtoLocal);
            }}
            style={{ width: '100%' }} placeholder="Selecione um Estágio" />;
    }

    function reorderEstagiosPlano(planosEstagio: ProdutoEstagioPlano[]) {
        let listaLocal = [...planosEstagio];
        listaLocal.sort((a, b) => {
            if (a.estagioRoteiro.sequencial > b.estagioRoteiro.sequencial) {
                return 1;
            }
            if (a.estagioRoteiro.sequencial < b.estagioRoteiro.sequencial) {
                return -1;
            }
            return 0;
        });


        return listaLocal;
    }

    function editorPlanoInspecao(options: any) {
        return <AutoComplete
            dropdown
            value={options.rowData.planoInspecao}
            placeholder="Selecione um Plano de Inspeção"
            style={{ width: '100%' }}
            inputStyle={{ width: '100%' }}
            field="nome"
            suggestions={planosInspecaoEstagioFiltrados}
            completeMethod={(e) => {
                let query = e.query;
                let filtered: PlanoInspecao[] = [];
                for (let i = 0; i < planosInspecaoEstagio.length; i++) {
                    let plano = planosInspecaoEstagio[i];
                    if (plano.nome.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                        filtered.push(plano);
                    }
                }
                setPlanosInspecaoEstagioFiltrados(filtered);
            }}
            onChange={(e) => {
                let produtoLocal = JSON.parse(JSON.stringify(produto));
                if (!e.target.value) {
                    produtoLocal.planosEstagio[options.rowIndex].planoInspecao = null;
                } else if (typeof e.target.value == "string") {
                    let plano = new PlanoInspecao();
                    plano.nome = e.target.value;
                    produtoLocal.planosEstagio[options.rowIndex].planoInspecao = plano;
                } else {
                    produtoLocal.planosEstagio[options.rowIndex].planoInspecao = e.target.value;
                }
                options.rowData['planoInspecao'] = produtoLocal.planosEstagio[options.rowIndex].planoInspecao;

                setProduto(produtoLocal);
            }}

        />
    }

    const editorOperacao = (options: any) => {
        return <Dropdown
            value={options.rowData.operacao}
            options={operacoes}
            optionLabel='descricao'
            onChange={(e) => {

                let operacoesLocal = [...produto.operacoes];
                options.rowData['operacao'] = e.target.value;

                operacoesLocal[options.rowIndex] = options.rowData;

                let produtoLocal = { ...produto };
                produtoLocal.operacoes = operacoesLocal;

                setProduto(produtoLocal);
            }}
            style={{ width: '100%' }} placeholder="Selecione uma operação" />;
    }

    const codigoKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            if (!produto.codigo) {
                produtoService.proximoCodigo().then((data) => {
                    setProduto({ ...produto, codigo: data });
                    setFocus("nome")
                    clearErrors("codigo")
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }

    return (

        <BaseCadastro model={produto} service={produtoService} setModel={(value: Produto) => setProduto(value)} novoCadastro getNewModel={() => new Produto()}
            validar={() => validar()} validarPersonalizado={() => validarPersolizado()} urlService="/produto" pathCadastro="/produto" tituloPagina={'Produto'} isModal={props.isModal} onSave={props.onSave}>
            {visibleDuplicarComponentes ? <ModalDuplicarComponentes
                onCancel={() => setVisibleDuplicarComponentes(false)}
                onConfirm={(componentes: ComponenteProduto[]) => {
                    componentes.forEach((item: ComponenteProduto) => {
                        item.id = 0;
                        item.produto = null;
                    });
                    setProduto({ ...produto, componentes: componentes });
                    setVisibleDuplicarComponentes(false);
                }}
                visible={visibleDuplicarComponentes}
            /> : null}

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}
            <TabView renderActiveOnly={false}>
                <TabPanel header="Geral">
                    <div style={{ display: "flex" }}>
                        <Checkbox
                            checked={produto.ativo}
                            onChange={(e) => { setProduto({ ...produto, ativo: e.checked as boolean }) }}
                            style={{ marginRight: 5 }}
                        />
                        <label>Ativo?</label>
                    </div>

                    {contaService.temModulo(modulosDisponiveis, "MDL_QLD") ? <div style={{ display: "flex", marginTop: 10 }}>
                        <Checkbox
                            checked={produto.entraBloqueado}
                            onChange={(e) => { setProduto({ ...produto, entraBloqueado: e.checked as boolean }) }}
                            style={{ marginRight: 5 }}
                        />
                        <label>Necessita Análise?</label>
                    </div> : null}

                    {contaService.temModulo(modulosDisponiveis, "MDL_PATR") ? <div style={{ display: "flex", marginTop: 10 }}>
                        <Checkbox
                            checked={produto.patrimoniavel}
                            onChange={(e) => { setProduto({ ...produto, patrimoniavel: e.checked as boolean }) }}
                            style={{ marginRight: 5 }}
                        />
                        <label>Patrimoniavel?</label>
                    </div> : null}

                    <div className="row">
                        <Label className="col col-sm-12" obrigatorio>Código</Label>
                        <div className="col-sm-12">
                            <InputText
                                className={errors.codigo ? "p-invalid" : ""}
                                disabled={editando} value={produto.codigo || ""} maxLength={20}
                                onKeyDown={codigoKeyDown}
                                style={{ width: '50%' }}
                                {...register("codigo", {
                                    onChange: (e) => {
                                        clearErrors("codigo")
                                        setProduto({ ...produto, codigo: e.target.value })
                                    }
                                })}
                            />
                        </div>
                        {errors.codigo && errors.codigo.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.codigo?.message as string}</span> : null}
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12">Código Interno</Label>
                        <div className="col-sm-12">
                            <InputText value={produto.codigoInterno || ""} maxLength={20} onChange={(e) => setProduto({ ...produto, codigoInterno: e.target.value })} style={{ width: '50%' }} />
                        </div>
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12" obrigatorio>Nome</Label>
                        <div className="col-sm-12">
                            <InputText
                                className={errors.nome ? "p-invalid" : ""}
                                value={produto.nome}
                                style={{ width: '50%' }}
                                {...register("nome", {
                                    onChange: (e) => {
                                        clearErrors("nome")
                                        setProduto({ ...produto, nome: e.target.value })
                                    }
                                })}
                            />
                        </div>
                        {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12" obrigatorio>Familia</Label>
                        <div className="col-sm-12">
                            <Controller name="familiaProduto" control={control} render={({ field }) => (
                                <Dropdown
                                    className={errors.familiaProduto ? "p-invalid" : ""}
                                    focusInputRef={field.ref}
                                    value={produto.familiaProduto}
                                    options={familias}
                                    optionLabel="nome"
                                    onChange={(e) => {
                                        clearErrors("familiaProduto");
                                        setProduto({ ...produto, familiaProduto: e.value })
                                    }}
                                    style={{ width: '30%' }}
                                />
                            )} />

                        </div>
                        {errors.familiaProduto && errors.familiaProduto.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.familiaProduto?.message as string}</span> : null}
                    </div>

                    {props.isPatrimonio ? null : <div className="row">
                        <Label className="col col-sm-12" obrigatorio>Tipo</Label>
                        <div className="col-sm-12">
                            <Controller name="tipo" control={control} render={({ field }) => (
                                <Dropdown
                                    className={errors.tipo ? "p-invalid" : ""}
                                    focusInputRef={field.ref}
                                    value={produto.tipo} options={produtoService.getTiposProduto()}
                                    optionLabel="label" optionValue="value"
                                    onChange={(e) => {
                                        clearErrors("tipo")
                                        setProduto({ ...produto, tipo: e.value, planoInspecao: null })
                                    }}
                                    style={{ width: '30%' }}
                                />
                            )} />
                        </div>
                        {errors.tipo && errors.tipo.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.tipo?.message as string}</span> : null}
                    </div>}

                    {props.isPatrimonio ? null : <div className="row">
                        <Label className="col col-sm-12" obrigatorio>Unidade de Medida</Label>
                        <div className="col-sm-12">
                            <Controller name="unidadeMedida" control={control} render={({ field }) => (
                                <Dropdown
                                    className={errors.unidadeMedida ? "p-invalid" : ""}
                                    focusInputRef={field.ref}
                                    value={produto.unidadeMedida} options={produtoService.getUnidadesMedida()}
                                    optionLabel="label" optionValue="value"
                                    onChange={(e) => {
                                        clearErrors("unidadeMedida")
                                        setProduto({ ...produto, unidadeMedida: e.target.value })
                                    }}
                                    style={{ width: '30%' }}
                                />
                            )} />
                        </div>
                        {errors.unidadeMedida && errors.unidadeMedida.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.unidadeMedida?.message as string}</span> : null}
                    </div>}

                    {props.isPatrimonio ? null : <div className="row">
                        <Label className="col col-sm-12">Quantidade Mínima</Label>
                        <div className="col-sm-12">
                            <InputNumber value={produto.qtdMinima}
                                locale="pt-BR"
                                useGrouping={false}
                                maxFractionDigits={5}
                                minFractionDigits={0}
                                max={999999999}
                                onChange={(e) => {
                                    setProduto({ ...produto, qtdMinima: e.value as number })
                                }}
                                style={{ width: '30%' }} />
                        </div>
                    </div>}

                    {contaService.temModulo(modulosDisponiveis, "MDL_PRD") ? <div className="row">
                        <Label className="col col-sm-12">Quantidade Saca</Label>
                        <div className="col-sm-12">
                            <InputNumber value={produto.qtdSaca}
                                useGrouping={false}
                                maxFractionDigits={6}
                                minFractionDigits={0}
                                max={9999999999}
                                onChange={(e) => {
                                    setProduto({ ...produto, qtdSaca: e.value as number })
                                }}
                                style={{ width: '30%' }} />
                        </div>
                    </div> : null}

                    {contaService.temModulo(modulosDisponiveis, "MDL_PRD") ? <div className="row">
                        <Label className="col col-sm-12">Validade em meses</Label>
                        <div className="col-sm-12">
                            <InputNumber value={produto.nrValidadeMeses}
                                useGrouping={false}
                                maxFractionDigits={0}
                                minFractionDigits={0}
                                max={9999999999}
                                onChange={(e) => {
                                    setProduto({ ...produto, nrValidadeMeses: e.value as number })
                                }}
                                style={{ width: '30%' }} />
                        </div>
                    </div> : null}

                    {contaService.temModulo(modulosDisponiveis, "MDL_PRD") ? <div className="row">
                        <Label className="col col-sm-12">Roteiro</Label>
                        <div className="col-sm-12">
                            <Dropdown
                                value={produto.roteiro} options={roteiros} optionLabel="label" optionValue="value"
                                onChange={(e) => {
                                    if (produto.componentes.length > 0) {
                                        confirmDialog({
                                            message: "Ao alterar o roteiro, os componentes serão apagados. Deseja continuar?",
                                            header: "Atenção", icon: "pi pi-exclamation-triangle",
                                            accept: () => {
                                                setProduto({ ...produto, componentes: [], roteiro: e.value });
                                            },
                                            reject: () => { },
                                            acceptLabel: "Sim", rejectLabel: "Não",
                                            acceptClassName: "p-button-danger", rejectClassName: "p-button-info"
                                        });
                                    } else {
                                        setProduto({ ...produto, roteiro: e.value });
                                    }

                                }}
                                style={{ width: '30%' }}
                            />
                        </div>
                    </div> : null}
                    {contaService.temModulo(modulosDisponiveis, "MDL_PRD") || contaService.temModulo(modulosDisponiveis, "MDL_QLD") ? <div className="row">
                        <Label className="col col-sm-12">Plano de inspeção</Label>
                        <div className="col-sm-12">
                            <Controller name="planoInspecao" control={control} render={({ field }) => (
                                <AutoComplete
                                    inputRef={field.ref}
                                    inputClassName={errors.planoInspecao ? "p-invalid" : ""}
                                    dropdown
                                    value={produto.planoInspecao}
                                    placeholder="Selecione um Plano de Inspeção"
                                    style={{ width: '30%' }}
                                    inputStyle={{ width: '100%' }}
                                    field="nome"
                                    itemTemplate={(item: PlanoInspecao) => { return item.codigoInterno + " - " + item.nome }}
                                    suggestions={planosInspecaoAcabadoFiltrados}
                                    completeMethod={(e) => {
                                        let query = e.query;
                                        let filtered: PlanoInspecao[] = [];
                                        let planos = produto.tipo == "COMPRADO" ?
                                            planosInspecaoRecebimento :
                                            produto.tipo === "PRODUZIDO" ?
                                                planosInspecaoAcabado :
                                                [...planosInspecaoAcabado, ...planosInspecaoRecebimento];
                                        for (let i = 0; i < planos.length; i++) {
                                            let plano: PlanoInspecao = planos[i];
                                            if (plano.codigoInterno.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                                                filtered.push(plano);
                                            } else if (plano.nome.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                                                filtered.push(plano);
                                            } else if ((plano.codigoInterno + " - " + plano.nome).toLowerCase().indexOf(query.toLowerCase()) == 0) {
                                                filtered.push(plano);
                                            }
                                        }
                                        setPlanosInspecaoAcabadoFiltrados(filtered);
                                    }}
                                    onChange={(e) => {
                                        clearErrors("planoInspecao")
                                        let produtoLocal = JSON.parse(JSON.stringify(produto));
                                        if (!e.target.value) {
                                            produtoLocal.planoInspecao = null;
                                        } else if (typeof e.target.value == "string") {
                                            let plano = new PlanoInspecao();
                                            plano.nome = e.target.value;
                                            produtoLocal.planoInspecao = plano;
                                        } else {
                                            produtoLocal.planoInspecao = e.target.value;
                                        }

                                        setProduto(produtoLocal);
                                    }}

                                />
                            )} />
                        </div>
                        {errors.planoInspecao && errors.planoInspecao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.planoInspecao?.message as string}</span> : null}
                    </div> : null}

                </TabPanel>
                <TabPanel header="Dados Fiscais">
                    <div className="row">
                        <Label className="col col-sm-12">Classificação Fiscal</Label>
                        <div className="col-sm-12">
                            <Dropdown
                                value={produto.classificacaoFiscal?.id ?? null}
                                options={classificacoesFiscais}
                                optionLabel="descricao"
                                optionValue="id"
                                filter
                                showClear
                                placeholder="Selecione uma classificação fiscal"
                                onChange={(e) => setProduto({
                                    ...produto,
                                    classificacaoFiscal: classificacoesFiscais.find(item => item.id === e.value) ?? null
                                })}
                                style={{ width: '50%' }}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12">EAN</Label>
                        <div className="col-sm-12">
                            <InputText value={produto.ean ?? ""} maxLength={14}
                                onChange={(e) => setProduto({ ...produto, ean: e.target.value || null })}
                                style={{ width: '50%' }} />
                        </div>
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12">Origem da Mercadoria</Label>
                        <div className="col-sm-12">
                            <Dropdown value={produto.origemMercadoria} options={produtoService.getOrigensMercadoria()}
                                optionLabel="label" optionValue="value" showClear
                                placeholder="Selecione a origem da mercadoria"
                                onChange={(e) => setProduto({ ...produto, origemMercadoria: e.value })}
                                style={{ width: '50%' }} />
                        </div>
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12">Unidade Tributável</Label>
                        <div className="col-sm-12">
                            <InputText value={produto.unidadeTributavel ?? ""} maxLength={6}
                                onChange={(e) => setProduto({ ...produto, unidadeTributavel: e.target.value || null })}
                                style={{ width: '50%' }} />
                        </div>
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12">Conversão para Unidade Tributável</Label>
                        <div className="col-sm-12">
                            <InputNumber value={produto.conversaoUnidadeTributavel} locale="pt-BR"
                                useGrouping={false} minFractionDigits={0} maxFractionDigits={6} min={0}
                                onValueChange={(e) => setProduto({ ...produto, conversaoUnidadeTributavel: e.value ?? null })}
                                style={{ width: '50%' }} />
                        </div>
                    </div>
                    <CamposParametrosFiscais dados={produto} campos={camposFiscal} vertical
                        onChange={campos => setProduto({ ...produto, ...campos })} />
                </TabPanel>
                {contaService.temModulo(modulosDisponiveis, "MDL_PRD") ? <TabPanel header="Componentes" disabled={!produto.roteiro}>
                    <div className="row">
                        <div className="col-sm-12">
                            <BaseDataTableEdit
                                isSelection={false}
                                tituloLista="Componentes por estágio"
                                getNewModel={() => new ComponenteProduto()}
                                dataKey="key"
                                lista={produto.componentes ? produto.componentes : []}
                                setLista={(value: any) => setProduto({ ...produto, componentes: value })}
                                scrollable
                                scrollHeight='500px'
                                reordable
                                rowCancelDisabled={(rowData) => { return !rowData.componente?.codigo || !rowData.estagioRoteiro?.estagio?.nome }}
                                onRowReorder={(e) => {
                                    let seqRoteiro = 0;
                                    let seqComponente = 1;
                                    for (let i = 0; i < e.value.length; i++) {

                                        if ((e.value[i] as ComponenteProduto).estagioRoteiro.sequencial < seqRoteiro) {
                                            console.log("movimentação inválida, :" + (e.value[i] as ComponenteProduto).estagioRoteiro.sequencial + " < " + seqRoteiro);
                                            return
                                        } else if ((e.value[i] as ComponenteProduto).estagioRoteiro.sequencial > seqRoteiro) {
                                            seqRoteiro = (e.value[i] as ComponenteProduto).estagioRoteiro.sequencial;
                                            seqComponente = 1;
                                        } else {
                                            seqComponente++;
                                        }

                                        (e.value[i] as ComponenteProduto).sequencial = seqComponente;
                                    }
                                    produto.componentes = e.value as ComponenteProduto[];
                                    setProduto({ ...produto });


                                }}
                                onDeleteRow={(list) => {

                                    let sequencial = 1;
                                    let seqEstagio = 0;

                                    for (let i = 0; i < list.length; i++) {
                                        if (list[i].estagioRoteiro?.sequencial != seqEstagio) {
                                            seqEstagio = list[i].estagioRoteiro?.sequencial || 0;
                                            sequencial = 1;
                                        }

                                        list[i].sequencial = sequencial;
                                        sequencial++;
                                    }
                                }}
                                defaultSequencial={0}
                                rowGroupMode="subheader" groupRowsBy="estagioRoteiro.estagio.nome"
                                rowGroupHeaderTemplate={rowGroupHeaderTemplate} rowGroupFooterTemplate={rowGroupFooterTemplate}
                                extraButtons={<>
                                    <Button style={{ marginRight: 8 }} onClick={() => setVisibleDuplicarComponentes(true)}>Duplicar</Button>
                                </>}
                            >
                                <Column rowReorder style={{ width: '3em' }} />
                                <Column field="estagioRoteiro.estagio.nome" header="Estágio" editor={editorEstagio} />
                                <Column field="sequencial" header="Sequencial" />
                                <Column field="componente.nome" header="Componente" editor={editorComponente} body={(rowData) => {
                                    return <span style={rowData.componente?.codigo ? {} : { color: "#FF0000" }}>{rowData.componente?.codigoInterno ? rowData.componente.codigoInterno + " - " + rowData.componente.nome : rowData.componente?.nome}</span>
                                }} />
                                <Column field="quantidade" header="Quantidade" body={(rowdata) => {
                                    return rowdata.quantidade + (isKgouLt(rowdata.componente?.unidadeMedida) ? "%" : "");
                                }} editor={editorQuantidade} />
                                <Column header="Custo" body={(rowData) => {
                                    let custo = 0;

                                    if (rowData.componente.precoMedio != null) {
                                        if (isKgouLt(rowData.componente.unidadeMedida)) {
                                            custo = (rowData.quantidade / 100) * rowData.componente.precoMedio;
                                        } else {
                                            custo = rowData.quantidade * rowData.componente.precoMedio;
                                        }
                                    }

                                    return <span>{custo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                }} />
                                <Column field="componente.unidadeMedida" header="Uni. Med." style={{ width: '7em' }} />
                                <Column field="observacao" header="Observação" editor={(options) => editorObservacaoComponente(options)} />
                            </BaseDataTableEdit>
                        </div>
                    </div>
                </TabPanel> : null}
                {contaService.temModulo(modulosDisponiveis, "MDL_PRD") ? <TabPanel header="Plano de inspeção por Estágio" disabled={!produto.roteiro} >
                    <div className="row">
                        <div className="col-sm-12">
                            <BaseDataTableEdit
                                tituloLista="Plano de inspeção por estágio"
                                getNewModel={() => new ProdutoEstagioPlano()}
                                dataKey="key"
                                lista={produto.planosEstagio ? produto.planosEstagio : []}
                                setLista={(value: any) => setProduto({ ...produto, planosEstagio: value })}
                                scrollable
                                scrollHeight='500px'
                            >
                                <Column field="estagioRoteiro.estagio.nome" header="Estágio" editor={editorEstagioPlano} />
                                <Column field="planoInspecao.descricao" header="Plano de inspecao" editor={editorPlanoInspecao} style={{ width: '60%' }} />
                            </BaseDataTableEdit>
                        </div>
                    </div>
                </TabPanel> : null}
                {visibleOperacoes ? <TabPanel header="Operações" disabled={produto.tipo !== "PRODUZIDO"}>
                    <div className="row">
                        <div className="col-sm-12">
                            <BaseDataTableEdit
                                tituloLista="Operações"
                                getNewModel={() => new ProdutoOperacao()}
                                dataKey="key"
                                lista={produto.operacoes ? produto.operacoes : []}
                                setLista={(value: any) => setProduto({ ...produto, operacoes: value })}
                                scrollable
                                scrollHeight='500px'
                                reordable
                                onRowReorder={(e) => {
                                    e.value.forEach((item: any, index: number) => {
                                        item.sequencial = index + 1;
                                    });
                                    produto.operacoes = e.value as ProdutoOperacao[];
                                    setProduto({ ...produto });
                                }}
                            >
                                <Column rowReorder style={{ width: '3em' }} />
                                <Column field="operacao.descricao" header="Operação" editor={editorOperacao} style={{ width: '80%' }} />
                            </BaseDataTableEdit>
                        </div>
                    </div>
                </TabPanel> : null}
                {!props.isPatrimonio ? <TabPanel header="Preço" >
                    <div style={{ display: "flex" }}>
                        <Checkbox
                            checked={produto.precoCongelado}
                            onChange={(e) => { setProduto({ ...produto, precoCongelado: e.checked as boolean }) }}
                            style={{ marginRight: 5 }}
                        />
                        <label>Preço congelado</label>
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12">Preço médio</Label>
                        <div className="col-sm-12" style={{ width: "30%" }}>
                            <InputMonetario value={produto.precoMedio as number}
                                onChange={(e) => { setProduto({ ...produto, precoMedio: e }) }} />
                        </div>
                    </div>
                    <div className="row">
                        <Label className="col col-sm-12">Usuário da última alteração</Label>
                        <div className="col-sm-12">
                            <InputText value={produto.usuarioAlteracaoPreco?.nome || ""} readOnly style={{ width: '30%' }} />
                        </div>
                    </div>
                    <div className="row">
                        <Label className="col col-sm-12">Data da última alteração</Label>
                        <div className="col-sm-12">
                            <InputText value={converterDataHora(produto.dataAlteracaoPreco)} readOnly style={{ width: '30%' }} />
                        </div>
                    </div>
                </TabPanel> : null}
            </TabView>
        </BaseCadastro>
    )
}
